import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { string } from "yup";

import { SocialSecurityNumberInputField } from "./SocialSecurityNumberInputField";
import { SocialSecurityNumberInputSummaryField } from "./SocialSecurityNumberInputSummaryField";
import { FieldType } from "../types";

export function SocialSecurityNumberField(
  field: components["schemas"]["SocialSecurityNumberCheckField"]
): FieldType<components["schemas"]["SocialSecurityNumberCheckField"]> {
  return {
    field,
    inputElement: (
      <SocialSecurityNumberInputField key={field.name} field={field} />
    ),
    summaryElement: () => (
      <SocialSecurityNumberInputSummaryField key={field.name} field={field} />
    ),
    schema: socialSecurityNumberFieldSchema,
    initialValue: field.value,
  };
}

export const socialSecurityNumberFieldSchema = string()
  .required(t("Social security number is a required field"))
  .matches(
    /^(?!000|666)[0-8][0-9]{2}(?!00)[0-9]{2}(?!0000)[0-9]{4}$/,
    t("Please check that the value you have entered is a valid SSN")
  );
